<template>
  <div class="page p-b-8">
    <div class="banner">
      <div
        class="banner-img"
        style="background-image: url(https://static.wkanx.com/w002/M00/05/B3/CgIXGF6EPJaAOtDvAADDUYrfBag326.jpg)"
      ></div>
      <div class="abs-center-hv" style="font-size: 28px">
        <div style="transform: translate(-100px, -50px)">
          <div v-parallax="0.15">联系我们</div>
        </div>
      </div>
    </div>
    <div class="brick tc">
      <div class="fs16 fwb">官方微信</div>
      <div class="m-b-1">（用户名：WiFiMasterKey）</div>
      <img src="https://static.wkanx.com/w002/M00/05/B4/CgIXgV6EPcGAZZkAAAA-okCopgw850.jpg" width="86" alt />
      <div class="fs16 fwb m-b-2 m-t-8 p-t-4">广告咨询合作</div>
      <div>
        广告合作客服邮箱：
        <a href="mailto:yt@zenmen.com">yt@zenmen.com</a>
      </div>
      <!-- <div>广告合作客服QQ：3007314925</div> -->
      <div class="fs16 fwb m-b-2 m-t-8 p-t-4">客服电话</div>
      <div>
        广告合作客服电话：
        <a href="tel:010-821596432">13818759977</a>
      </div>
    </div>
    <div class="bg-blue tc address brick">
      <div class="fs16 fwb m-b-6">公司地址</div>
      <div class="m-b-4">上海：上海市浦东新区张衡路666弄1号7楼，总机电话021-68639700</div>
      <div class="img">
        <img src="https://static.wkanx.com/w002/M00/05/B4/CgIXGF6EPtmAOAXeAAGFz0vTXI8629.jpg" width="500" alt />
      </div>
      <div class="m-b-4">北京：北京市海淀区创业路6号自主创新大厦4楼</div>
      <div class="img">
        <img src="https://static.wkanx.com/w002/M00/05/B4/CgIXgV6EPweADzOfAAINLx4M5BI086.jpg" width="500" alt />
      </div>
      <div class="m-b-4">南京：江苏省南京市建邺区白龙江东街8号A3栋16层南</div>
      <div class="img">
        <img src="https://static.wkanx.com/w002/M00/05/B4/CgIXGF6EPwCAMf68AAGA6XY-nwY136.jpg" width="500" alt />
      </div>
      <div class="m-b-4">广州（分公司）：广州市天河区林和东路285号天安人寿1703-1704单元</div>
      <div class="img">
        <img src="https://static.wkanx.com/w002/M00/05/B4/CgIXlV6EPxOAdEmVAAFA3BIlFYM271.jpg" width="500" alt />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: '',
  props: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {},
  created() {},
  mounted() {},
};
</script>
<style lang="scss" scoped>
.address {
  .img {
    margin: 0 0 65px;
    display: inline-block;
    border-radius: 10px;
    overflow: hidden;
  }
  img {
    display: block;
    transition: transform 0.3s;
    &:hover {
      transform: scale(1.05);
    }
  }
}
</style>
